import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { RolePricingSchemeLinkService } from "blg-akaun-ts-lib";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "../../../../visa";
import { of } from "rxjs";
import { catchError, exhaustMap, map, mergeMap } from "rxjs/operators";
import { ClientSidePermissionsActions } from "../../client-side-permissions-controller/actions";
import { PermissionFacade } from "../../facades/permission.facade";
import { RolePricingSchemeLinkActions } from "../actions";

@Injectable()
export class RolePricingSchemeLinkPermissionsEffects {
  createRolePricingSchemeLink$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolePricingSchemeLinkActions.createRolePricingSchemeLinkInit),
      mergeMap((action) =>
        this.rolePricingSchemeLinkService
          .createRolePricingPermissionLink(
            action.RolePricingSchemeLink,
            this.appletGuid,
            action.tenantGuid,
            action.rank,
            AppConfig.apiVisa
          )
          .pipe(
            map((_) => {
              this.displayToasterSuccess(
                "Role pricing scheme link created successfully"
              );
              this.onReturn();
              return RolePricingSchemeLinkActions.createRolePricingSchemeLinkSuccess();
            }),
            catchError((err) => {
              this.displayToasterError(err.message);
              return of(
                RolePricingSchemeLinkActions.createRolePricingSchemeLinkFailure(
                  {
                    error: err.message,
                  }
                )
              );
            })
          )
      ),
      catchError((err) => {
        this.displayToasterError(err.message);
        return of(
          RolePricingSchemeLinkActions.createRolePricingSchemeLinkFailure({
            error: err.message,
          })
        );
      })
    )
  );

  deleteRolePricingSchemeLink$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolePricingSchemeLinkActions.deleteRolePricingSchemeLinkInit),
      exhaustMap((action) =>
        this.rolePricingSchemeLinkService
          .deleteRolePricingPermissionLink(
            action.guid,

            this.appletGuid,
            action.tenantGuid,
            action.rank,
            AppConfig.apiVisa
          )
          .pipe(
            map((_) => {
              this.displayToasterSuccess(
                "Role pricing scheme link deleted successfully"
              );
              this.onReturn();
              return RolePricingSchemeLinkActions.deleteRolePricingSchemeLinkSuccess();
            }),
            catchError((err) => {
              this.displayToasterError(err.message);
              return of(
                RolePricingSchemeLinkActions.deleteRolePricingSchemeLinkFailure(
                  { error: err.message }
                )
              );
            })
          )
      ),
      catchError((err) => {
        this.displayToasterError(err.message);
        return of(
          RolePricingSchemeLinkActions.deleteRolePricingSchemeLinkFailure({
            error: err.message,
          })
        );
      })
    )
  );

  updateRolePricingSchemeLink$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RolePricingSchemeLinkActions.updateRolePricingSchemeLinkInit),
      exhaustMap((action) =>
        this.rolePricingSchemeLinkService
          .getRolePricingPermissionLinkByGuid(
            action.RolePricingSchemeLink.bl_applet_role_pricing_scheme_link.guid.toString(),
            AppConfig.apiVisa,
            this.appletGuid,
            action.tenantGuid,
            action.rank
          )
          .pipe(
            map((a) => {
              a.data.bl_applet_role_pricing_scheme_link.pricing_scheme_guid =
                action.RolePricingSchemeLink.bl_applet_role_pricing_scheme_link.pricing_scheme_guid;
              a.data.bl_applet_role_pricing_scheme_link.role_guid =
                action.RolePricingSchemeLink.bl_applet_role_pricing_scheme_link.role_guid;
              return a.data;
            }),
            exhaustMap((b) =>
              this.rolePricingSchemeLinkService
                .updateRolePricingPermissionLink(
                  b,
                  this.appletGuid,
                  action.tenantGuid,
                  action.rank,
                  AppConfig.apiVisa
                )
                .pipe(
                  map((_) => {
                    this.displayToasterSuccess(
                      "Role pricing scheme link updated successfully"
                    );
                    this.onReturn();
                    return ClientSidePermissionsActions.updateClientSidePermSuccess();
                  }),
                  catchError((err) => {
                    this.displayToasterError(err.message);
                    return of(
                      ClientSidePermissionsActions.updateClientSidePermFailure({
                        error: err.message,
                      })
                    );
                  })
                )
            ),
            catchError((err) => {
              this.displayToasterError(err.message);
              return of(
                ClientSidePermissionsActions.updateClientSidePermFailure({
                  error: err.message,
                })
              );
            })
          )
      )
    )
  );

  authToken = localStorage.getItem("authToken");
  appletGuid = sessionStorage.getItem("appletGuid");
  tenantCode = sessionStorage.getItem("tenantCode");
  prevIndex: number;
  prevLocalState: any;

  constructor(
    private actions$: Actions,
    private permFacade: PermissionFacade,
    private rolePricingSchemeLinkService: RolePricingSchemeLinkService,
    private toaster: ToastrService
  ) {
    this.permFacade.prevIndex$.subscribe(
      (resolve) => (this.prevIndex = resolve)
    );
    this.permFacade
      .prevLocalState$()
      .subscribe((resolve) => (this.prevLocalState = resolve));
  }

  /**
   * Display a toaster when there is an error.
   *
   * @param message : the messsage to display
   * @returns the toaster
   */
  displayToasterError(message: string) {
    return this.toaster.error(message, "Error", {
      tapToDismiss: true,
      progressBar: true,
      timeOut: 1300,
    });
  }

  /**
   * Display a successful toaster message.
   *
   * @param message : the message to display
   * @returns the toaster
   */
  displayToasterSuccess(message: string) {
    return this.toaster.success(message, "Success", {
      tapToDismiss: true,
      progressBar: true,
      timeOut: 1300,
    });
  }

  onReturn() {
    this.permFacade.updateInstance(this.prevIndex, {
     ...this.prevLocalState,
     deactivateAdd: false,
     deactivateList: false,
   });
   console.log(" Previous Index applet ", this.prevIndex);
   this.permFacade.onPrev(this.prevIndex);
 }
}
